// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__6HvDY","date":"style_date__IshX1","date_fromTo":"style_date_fromTo__ccxJz","date_error":"style_date_error__qarh3","delete":"style_delete__64DR+"};